import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { SalesPurchaseProperty } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SalesPurchasePropertyService extends TmsWebBaseEditService<SalesPurchaseProperty, SalesPurchaseProperty> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SalesPurchaseProperty', $localize`Sales Purchase Property`, httpService, notificationService);
  }

  getProperties(sales: boolean, purchases: boolean): Observable<SalesPurchaseProperty[]> {
    return this.httpService.get<SalesPurchaseProperty[]>(
      `${this.apiUrl}/GetProperties?sales=${sales}&purchases=${purchases}`,
    );
  }
}
